import {Injectable, Component, OnInit, ApplicationRef} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ErrorModalComponent} from '../error-modal/error-modal.component';
import {UploadModalComponent} from '../upload-modal/upload-modal.component';
import {SuccessModalComponent} from '../success-modal/success-modal.component';
import {HttpClient, HttpParams} from '@angular/common/http';
import {DataSharingService} from '../data-sharing.service';
import 'rxjs' ;
import {saveAs} from 'file-saver';


@Component({
  selector: 'pm-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['../upload-file/upload-file.component.css',
    '../home/welcome.component.css', '../error-modal/error-modal.component.css', '../app.component.css']
})
@Injectable()
export class UploadFileComponent implements OnInit {

  selectedFile: string = '';
  extention: string = '';
  modalRef: any;
  errorMessage: any;
  fileNameCsv: any;
  lengthCsv: any;
  errorMessageModal: any;
  successMessage: any;
  fileName: any;
  message: string = 'loading :(';
  app: ApplicationRef;
  userDetails: any;
  additionalInfo: any;
  fileFormat: any = 'standard';
  uploadFileFormat: any;

  constructor(private _http: HttpClient,
              private modalService: NgbModal,
              private _data: DataSharingService) {
  }

  fileUpload(value: string, event) {
    const fileList: FileList = event.target.files;
    let response: any;
    this.fileNameCsv = value.split('.');
    this.fileName = value.split('\\');
    this.lengthCsv = this.fileNameCsv.length;
    this.extention = this.fileNameCsv[this.lengthCsv - 1];
    if (this.extention === 'csv') {
      const _size = fileList[0].size;
      // limit of upload file = 5 MB
      const sizeLimit = 1024 * 1024 * 5;
      if (_size <= sizeLimit) {
        this.selectedFile = this.fileName[this.fileName.length - 1];
        this.modalRef = this.modalService.open(UploadModalComponent, {
          backdrop: 'static',
          keyboard: false
        }).componentInstance;
        this.modalRef.widthProgressValue = 'done';
        this.modalRef.modalText = 'Uploading';
        this.modalRef.modcontent = 'File uploading. . .Please wait. . .';
        this.modalRef.changeWidth(30);
        response = this.fileUploadServiceCall(event);
        response.subscribe(
          (data : any) => {
            this.errorMessage = JSON.stringify(data.errorMessage);
            this.modalRef.widthProgressValue = 'not done';
            this.modalRef.delete();
            this.successMessage = (JSON.stringify(data.message)).split('"')[1];
            this.errorMessage = JSON.stringify(data.errorMessage);
            this.modalRef = this.modalService.open(SuccessModalComponent,
              {size: 'sm', backdrop: 'static', keyboard: false, windowClass: 'sucessModal'}).componentInstance;
            this.modalRef.updateUsers = false; //  EC-686
            this.modalRef.modalText = this.successMessage;
            this.modalRef.modcontent = this.successMessage;
          },
          (error : any) => {
            this.modalRef.delete();
            this.modalRef = this.modalService.open(ErrorModalComponent,
              {size: 'sm', backdrop: 'static', keyboard: false, windowClass: 'test'}).componentInstance;
            this.errorMessage = JSON.stringify(error.error.errorMessage);
            if (this.errorMessage === undefined) {
              this.modalRef.modcontent = 'An Internal error occured' + '<br/>' + 'Please try again.';
            } else {
              this.errorMessageModal = this.errorMessage.replaceAll('"', '')
              this.modalRef.modcontent = this.errorMessageModal;
            }
            this.modalRef.modalText = 'File Uploading Failed. ';
          }
        );
      } else {
        this.modalRef = this.modalService.open(ErrorModalComponent,
          {size: 'sm', backdrop: 'static', keyboard: false, windowClass: 'test'}).componentInstance;
        this.modalRef.modalText = 'File Uploading Failed. ';
        this.modalRef.modcontent = 'File size error - Your file size is over 5 MB and\
                can\'t be uploaded. Please upload a smaller file. ';
      }
    } else if (this.extention !== '' && this.extention !== 'csv') {
      this.modalRef = this.modalService.open(ErrorModalComponent,
        {size: 'sm', backdrop: 'static', keyboard: false, windowClass: 'test'}).componentInstance;
      this.modalRef.modalText = 'File Uploading Failed. ';
      this.modalRef.modcontent = 'Please enter file in' + '<br/>' + '.csv format.';
    }
    this.uploadFileFormat = null;
  }

  fileUploadServiceCall(event) {
    const fileList: FileList = event.target.files;
    const file: File = fileList[0];
    const formData: FormData = new FormData();
    formData.append('file', file, file.name);
    formData.append('type', 'Subscription');
    const postApi = window.location.origin + '/ftportal/api/upload';
    return this._http.post(postApi, formData);
  }

  downloadTemplate() {
    let params = new HttpParams();
    params = params.append('type', 'SalesFileTemplate')
      .append('fileFormat', this.fileFormat);
    this.fileFormat = this.fileFormat.charAt(0).toUpperCase() + this.fileFormat.slice(1);
    this._http.get(window.location.origin + '/ftportal/api/getTemplate', {responseType: 'blob', params: params})
      .subscribe(data => {
          const blob = new Blob([data], {type: 'text/csv'});
          saveAs(blob, 'eFT - ' + this.fileFormat + ` File Template.csv`);
        },
        error => this.errorMessage = <any>error);
  }

  downloadGuide() {
    let params = new HttpParams();
    params = params.append('type', 'SalesIntGuide')
      .append('fileFormat', this.fileFormat);
    this.fileFormat = this.fileFormat.charAt(0).toUpperCase() + this.fileFormat.slice(1);
    this._http.get(window.location.origin + '/ftportal/api/getTemplate', {responseType: 'blob', params: params})
      .subscribe(data => {
          const blob = new Blob([data], {type: 'pdf'});
          saveAs(blob, 'eFT-Integration Guide.pdf');
        },
        error => this.errorMessage = <any>error);
  }

  ngOnInit() {
    this._data.FileName.subscribe(value => this.selectedFile = value);
    this._http.get(window.location.origin + '/ftportal/user-info').subscribe(userDetails => {
        this.userDetails = userDetails;
        this.additionalInfo = this.userDetails.additional_info;
        if (this.userDetails.authorities[0] === 'ROLE_SUPER_ADMIN') {
          this.fileFormat = this.additionalInfo.split(',')[0];
        } else {
          this.fileFormat = this.additionalInfo.split(',')[1];
        }
      },
      err => {
      }
    );
  }
}
